import React from 'react';
import './Cover.less';

class Cover extends React.Component {
  render () {
    return (
      <section className="section section-cover">
        <figure className="img img-cow"/>
      </section>
    );
  }
}

export default Cover;



// WEBPACK FOOTER //
// ./src/components/Cover/Cover.js